'use client';
import { ProfileOrderDetailsModal } from '@modals';
import { motion } from 'motion/react';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

import { Button, Illustration } from '@/shared/ui';

import styles from './order-details.module.scss';

type OrderDetailsProps = {
  className?: string;
  isMobile?: boolean;
  item: any;
  orders?: 'purchases' | 'active-orders';
};

export const OrderDetailsFeature = ({
  className,
  isMobile,
  item,
  orders,
}: OrderDetailsProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const router = useRouter();

  return (
    typeof window !== 'undefined' && (
      <>
        <Button
          whileTap={{ scale: 0.95 }}
          id={'row-item'}
          as={motion.button}
          onClick={
            orders === 'purchases'
              ? () => setIsOpened(!isOpened)
              : () => router.push(`/order/${item.id}`)
          }
          className={styles['link-btn']}
          variant={'secondary'}
          text={
            isMobile && orders === 'active-orders'
              ? 'Go to order'
              : isMobile && orders === 'purchases'
                ? 'Details'
                : ''
          }
          iconRight={
            <Illustration
              name={'left'}
              spriteName={'icons'}
              spanTagClassName={styles['link-btn-icon']}
            />
          }
        />

        {isOpened && (
          <ProfileOrderDetailsModal
            orderId={item.id}
            isMobile={isMobile}
            isOpened={isOpened}
            handleClose={() => setIsOpened(false)}
          />
        )}
      </>
    )
  );
};
